import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import moment from "moment";

Vue.config.productionTip = false


Vue.filter('formatDate', function (value) {
    if (!value) return ''
    return moment(value).format("DD.MM.YYYY");
});

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');


router.beforeEach(function (to, from, next) {

    if ((to.path !== '/login' && to.path !== 'login') && !localStorage.ridtoken) {
        next({path: '/login'})
    } else if ((to.path === '/login' || to.path === 'login') && localStorage.ridtoken) {
        next({path: '/'})
    } else {
        next()
    }
});

if (localStorage.ridtoken == null || localStorage.baseUrl == null) {
    if (router.query != null && router.query.baseUrl != null) {
        +
            router.push("/login?baseUrl=" + router.query.baseUrl);
    } else {
        router.push("/login");
    }

}

